const SAMPLE_COUNTRIES = [
  { _id: "CA", country_name: "Canada", country_status: "Low Risk" },
  { _id: "JP", country_name: "Japan", country_status: "Low Risk" },
  { _id: "PT", country_name: "Portugal", country_status: "Low Risk" },
  { _id: "SG", country_name: "Singapore", country_status: "Low Risk" },
  { _id: "US", country_name: "United States", country_status: "Low Risk" },
  { _id: "BR", country_name: "Brazil", country_status: "Medium Risk" },
  { _id: "EG", country_name: "Egypt", country_status: "Medium Risk" },
  { _id: "IN", country_name: "India", country_status: "Medium Risk" },
  { _id: "MX", country_name: "Mexico", country_status: "Medium Risk" },
  { _id: "ZA", country_name: "South Africa", country_status: "Medium Risk" },
  { _id: "CO", country_name: "Colombia", country_status: "High Risk" },
  { _id: "NG", country_name: "Nigeria", country_status: "High Risk" },
  { _id: "PK", country_name: "Pakistan", country_status: "High Risk" },
  { _id: "UA", country_name: "Ukraine", country_status: "Extreme Warning" },
  { _id: "VE", country_name: "Venezuela", country_status: "High Risk" },
  { _id: "AQ", country_name: "Antarctica", country_status: "Unknown" },
];

export default SAMPLE_COUNTRIES;
